<footer class="footer-container" role="contentinfo" [attr.aria-label]="'redesign.footer.LANDMARK' | translate">

    <p-image class="footer-logo" [src]="logoImg" alt="" />

    <nav class="footer-nav" [attr.aria-label]="'redesign.footer.NAV_LABEL' | translate">
        <ul>
            @for (link of links; track link.labelKey) {
                <li>
                    <a class="footer-link" [href]="link.url" target="_blank" rel="noopener noreferrer"
                       [pTooltip]="'redesign.footer.OPENS_NEW_WINDOW' | translate" tooltipPosition="top">
                        {{ link.labelKey | translate }}
                        <!-- Externes-Link-Icon vorerst ausgeblendet; ggf. später wieder aktivieren:
                        <i class="footer-link-icon fa-regular fa-arrow-up-right-from-square" aria-hidden="true"></i>
                        -->

                        <span class="footer-visually-hidden">{{ 'redesign.footer.OPENS_NEW_WINDOW' | translate }}</span>
                    </a>
                </li>
            }
        </ul>
    </nav>

    <p class="footer-copyright">© {{ 'redesign.footer.COPYRIGHT' | translate }}</p>

</footer>
